/**
 * v3.21-1605 · Client-side mirror of backend `scope_guard.is_internal_user`.
 *
 * Ghost Daily Organizer, Ghost Floating Icon, Ghost polling, Ghost API
 * traffic — every one of these is gated by this predicate.  External
 * partners never see Ghost.
 *
 * Keep this in sync with backend/services/scope_guard.py.  A user is
 * internal iff:
 *   - role is `vo_officer`             → NEVER internal (per spec carve-out)
 *   - role starts with `ptc_`, `super_admin`, `owner`, `internal_`  → internal
 *   - company_type === "internal" AND role is not an external partner role
 */
const INTERNAL_ROLE_PREFIXES = ['ptc_', 'super_admin', 'owner', 'internal_'];
const EXTERNAL_PARTNER_ROLES = new Set([
  'company_admin', 'company_director', 'company_manager',
  'company_team_member', 'marketing_partner', 'external_partner',
]);
const EXTERNAL_ROLES_NO_GHOST = new Set([...EXTERNAL_PARTNER_ROLES, 'vo_officer']);

export function isInternalUser(user) {
  if (!user) return false;
  const role = String(user.role || '').toLowerCase().trim();
  if (role === 'vo_officer') return false;
  if (INTERNAL_ROLE_PREFIXES.some((p) => role.includes(p))) return true;
  const companyType = String(user.company_type || '').toLowerCase().trim();
  if (companyType === 'internal' && !EXTERNAL_ROLES_NO_GHOST.has(role)) return true;
  return false;
}

export default isInternalUser;
